import { ResumeApplicationModal } from '@Components/modal/resumeApplication/ResumeApplicationModal.tsx';
import { bugsnagClient } from '@Services/observability/initObservability';
import { router } from '@Routes/__root.tsx';
import { routesModel } from '@Router/router.consts.ts';
import { RoutesMap } from '@Router/router.types.ts';
import { getModalSetter } from './modalAccessor.ts';
import { ModalTypes } from './modal.types.ts';

const MAX_RETRIES = 20;
const RETRY_DELAY_MS = 100;
// TODO: work on the infra to solve this issue
// RouterProvider only renders after setAppState(AppStateTypes.READY)
// This is a temporary solution to show the modal after the app is ready

export const showResumeApplicationModal = (retryCount = 0) => {
  const currentPath = router?.state?.location?.pathname;
  if (currentPath === routesModel[RoutesMap.WELCOME].path) {
    return;
  }

  const setModal = getModalSetter();

  if (!setModal) {
    if (retryCount < MAX_RETRIES) {
      setTimeout(() => showResumeApplicationModal(retryCount + 1), RETRY_DELAY_MS);
      return;
    }
    bugsnagClient?.notify('showResumeApplicationModal Modal setter not available after retries');
    return;
  }

  const closeModal = () => {
    setModal({ isActive: false, type: ModalTypes.NONE, customComponent: undefined });
  };

  setModal({
    isActive: true,
    type: ModalTypes.CUSTOM,
    customComponent: <ResumeApplicationModal onClose={closeModal} />,
    blur: false,
    persistModal: true,
  });
};
